import { useEffect, useState } from 'react';
import DefaultParamsService from './services/defaultparams.service';
import TopAndSideBar from './TopAndSideBar';
import { NewHeader } from './AuxiliaryFunctions';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useDispatch, } from "react-redux";
import { logout } from "./actions/auth.js";
import styled from 'styled-components';
import MessageBox from './MessageBox.js';


const Label = styled.label`
	font-size: 1rem;
`;

const Input = styled.input`
  padding: 0.3rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
	height: 100%;
`;

const AdminSettings = () => {
	const defaultParamsId = 1;

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');

	const [defaultParams, setDefaultParams] = useState({});

	const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    DefaultParamsService.updateByPK(defaultParamsId, defaultParams)
    .then(resp => {
      console.log(resp);
      setShowsuccess(true);
      setSuccmessage(resp.data.message);
      setShowerror(false);
      return;
    })
    .catch(err => {
      if (err.response.status === 401) {
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
       console.log(err.response);
      }
      setShowsuccess(false);
      setErrmessage(err.response.data.message);
      setShowerror(true);
      return;
    });
  };

  const handleDefaultParamsChange = (e) => {
    const { name, value } = e.target;
    setDefaultParams((prev) => ({ ...prev, [name]: value }));
  };	

	useEffect (() => {
		DefaultParamsService.getByPK(1)
		.then(resp => {
			setDefaultParams(resp.data);
		})
		.catch(err => {
			console.log(err);
		});
	},[]);

	return (
		<>

      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"Default Parameters"}/>

        <Container>					
					<Form onSubmit={handleSubmit}>
						<h5>Assembly Cost</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>
							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Assembly Base / Wall Cost</Label>
								<Input
									type="number"
									step={"any"}
									name="assemblycostbasewallcost"
									defaultValue={defaultParams.assemblycostbasewallcost}
									onChange={handleDefaultParamsChange}
								/>  
							</div>

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Assembly Tall Cost</Label>
								<Input
									type="number"
									step={"any"}
									name="assemblycosttallcost"
									value={defaultParams.assemblycosttallcost}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	
						</div>
						<h5 className='mt-4'>Hardware Hinges</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>
							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Base Hardware Hinge by Cab</Label>
								<Input
									type="number"
									step={"any"}
									name="hardwarehingesbasewallcost"
									value={defaultParams.hardwarehingesbasewallcost}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Tall Hardware Hinge by Cab</Label>
								<Input
									type="number"
									step={"any"}
									name="hardwarehingestallcost"
									value={defaultParams.hardwarehingestallcost}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Hardware Hinge Cost</Label>
								<Input
									type="number"
									step={"any"}
									name="hardwarehingestotalcost"
									value={defaultParams.hardwarehingestotalcost}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	
						</div>

						<h5 className='mt-4'>Routing Cost</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>						
							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcost"
									value={defaultParams.routingcost}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	
						</div>

						<h5 className='mt-4'>Routing Cost - Case sqft</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>						
							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost sq ft Base</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostcasesqftbase"
									value={defaultParams.routingcostcasesqftbase}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost sq ft Wall</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostcasesqftwall"
									value={defaultParams.routingcostcasesqftwall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>													

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost sq ft Tall</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostcasesqfttall"
									value={defaultParams.routingcostcasesqfttall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>		
						</div>

						<h5 className='mt-4'>Routing Cost - Back sqft</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>																					

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Back Base</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostbacksqftbase"
									value={defaultParams.routingcostbacksqftbase}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Back Wall</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostbacksqftwall"
									value={defaultParams.routingcostbacksqftwall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>			

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Back Tall</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostbacksqfttall"
									value={defaultParams.routingcostbacksqfttall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>		

						</div>

						<h5 className='mt-4'>Routing Cost - Door sqft</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>									

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Door sqft Base</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostdoorssqftbase"
									value={defaultParams.routingcostdoorssqftbase}
									onChange={handleDefaultParamsChange}
								/>  
							</div>															

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Door sqft Wall</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostdoorssqftwall"
									value={defaultParams.routingcostdoorssqftwall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>																					

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Door sqft Tall</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostdoorssqfttall"
									value={defaultParams.routingcostdoorssqfttall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	
						</div>

						<h5 className='mt-4'>Routing Cost - Finished Ends sqft</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Finished Ends sqft Base</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostfinishendssqftbase"
									value={defaultParams.routingcostfinishendssqftbase}
									onChange={handleDefaultParamsChange}
								/>  
							</div>		

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Finished Ends sqft Wall</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostfinishendssqftwall"
									value={defaultParams.routingcostfinishendssqftwall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>		

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Routing Cost Finished Ends sqft Tall</Label>
								<Input
									type="number"
									step={"any"}
									name="routingcostfinishendssqfttall"
									value={defaultParams.routingcostfinishendssqfttall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

						</div>

						<h5 className='mt-4'>Material Costs Markups</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Material Cost Back Markup</Label>
								<Input
									type="number"
									step={"any"}
									name="materialcostbackmarkup"
									value={defaultParams.materialcostbackmarkup}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Material Cost Doors Markup</Label>
								<Input
									type="number"
									step={"any"}
									name="materialcostdoorsmarkup"
									value={defaultParams.materialcostdoorsmarkup}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Material Cost Finish Ends Markup</Label>
								<Input
									type="number"
									step={"any"}
									name="materialcostfinishendsmarkup"
									value={defaultParams.materialcostfinishendsmarkup}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Material Cost Case Markup</Label>
								<Input
									type="number"
									step={"any"}
									name="materialcostcasemarkup"
									value={defaultParams.materialcostcasemarkup}
									onChange={handleDefaultParamsChange}
								/>  
							</div>
						</div>

						<h5 className='mt-4'>EB Case lnft and Markup</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>							

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>EB Case Base lnft</Label>
								<Input
									type="number"
									step={"any"}
									name="ebcostcasebase"
									value={defaultParams.ebcostcasebase}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>EB Case Wall lnft</Label>
								<Input
									type="number"
									step={"any"}
									name="ebcostcasewall"
									value={defaultParams.ebcostcasewall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>EB Case Tall lnft</Label>
								<Input
									type="number"
									step={"any"}
									name="ebcostcasetall"
									value={defaultParams.ebcostcasetall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>EB Cost Case Markup</Label>
								<Input
									type="number"
									step={"any"}
									name="ebcostcasemarkup"
									value={defaultParams.ebcostcasemarkup}
									onChange={handleDefaultParamsChange}
								/>  
							</div>								
						</div>						

						<h5 className='mt-4'>EB Doors lnft and Markups</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>EB Doors Base lnft</Label>
								<Input
									type="number"
									step={"any"}
									name="ebcostdoorsbase"
									value={defaultParams.ebcostdoorsbase}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>EB Doors Wall lnft</Label>
								<Input
									type="number"
									step={"any"}
									name="ebcostdoorswall"
									value={defaultParams.ebcostdoorswall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>EB Doors Tall lnft</Label>
								<Input
									type="number"
									step={"any"}
									name="ebcostdoorstall"
									value={defaultParams.ebcostdoorstall}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>EB Cost Doors Markup</Label>
								<Input
									type="number"
									step={"any"}
									name="ebcostdoorsmarkup"
									value={defaultParams.ebcostdoorsmarkup}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

						</div>

						<h5 className='mt-4'>Drawer Costs and Markups</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Drawer Cost</Label>
								<Input
									type="number"
									step={"any"}
									name="drawercostdrawer"
									value={defaultParams.drawercostdrawer}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Drawer Cost Hardware</Label>
								<Input
									type="number"
									step={"any"}
									name="drawercosthardware"
									value={defaultParams.drawercosthardware}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Drawer Cost Markup</Label>
								<Input
									type="number"
									step={"any"}
									name="drawercostmarkup"
									value={defaultParams.drawercostmarkup}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	
						</div>

						<h5 className='mt-4'>Other Costs and Markups</h5>
						<div style={{flexWrap:'wrap',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'20px',}}>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Face Frame Markup</Label>
								<Input
									type="number"
									step={"any"}
									name="faceframemarkup"
									value={defaultParams.faceframemarkup}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Basic Delivery Cost</Label>
								<Input
									type="number"
									name="basicdeliverycost40cab"
									value={defaultParams.basicdeliverycost40cab}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

							<div style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'flex-start',gap:'10px'}}>
								<Label>Unknown Factor</Label>
								<Input
									type="number"
									step={"any"}
									name="unknownfactor"
									value={defaultParams.unknownfactor}
									onChange={handleDefaultParamsChange}
								/>  
							</div>	

						</div>

						<div>
							<Button className='btn btn-primary' type="submit">Update</Button>
						</div>
						
					</Form>

					<Container className="row" style={{width:'100vw',margin:'20px'}}>
						<Row className='mt-2'>
							{showerror && (
								<MessageBox show={true} showerror={showerror} errmessage={errmessage}
									onHide={() => {
										setShowerror(false)
									}}
								/>
							)}
							{showsuccess && (

								<MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
									onHide={() => {
									setShowsuccess(false);
								}}
								/>
							)}
							<hr/>    
						</Row>            
					</Container>

				</Container>

			</div>			
		</>
	)
};

export default AdminSettings;